import React from 'react';
import { ShieldCheck, ArrowRight } from 'lucide-react';
function handleAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      value: 6.39,
      currency: 'USD',
      content_name: 'Plan 21 Días Alta Proteína'
    });
  }
}
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 relative overflow-hidden bg-[#F2F1EE]" data-id="element-90">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-91">
        <div className="mb-12" data-id="element-92">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-[#DF1189]" data-id="element-93">
            Empieza este domingo
          </h2>
          <p className="text-xl text-charcoal-light max-w-2xl mx-auto" data-id="element-94">
            Te cuesta menos que 1–2 pedidos de comida rápida… <br data-id="element-95" />
            pero te da un sistema para 21 días (y reutilizable).
          </p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-terracotta/10 max-w-2xl mx-auto" data-id="element-96">
          <div className="mb-8" data-id="element-97">
            <span className="inline-block px-3 py-1 mb-3 text-sm font-bold tracking-wide rounded-full bg-[#DF1189] text-[#feecec]" data-id="element-98">
              🔥 Precio especial de descuento
            </span>
            <div className="flex items-center justify-center gap-3" data-id="element-99">
              <span className="text-2xl font-serif text-charcoal-light/50 line-through" data-id="element-100">
                $27
              </span>
              <span className="text-6xl font-serif font-bold text-[#DF1189]" data-id="element-101">
                $6.39
              </span>
            </div>
            <span className="text-charcoal-light text-lg" data-id="element-102">USD</span>
          </div>

          <a href="https://www.micambiodiario.com/cart/54232896930095:1" onClick={handleAddToCart} className="inline-flex items-center justify-center w-full px-8 py-5 font-bold text-xl rounded-xl shadow-lg hover:bg-terracotta-dark transition-all transform hover:-translate-y-1 mb-6 group bg-[#DF1189] text-[#EBEBEB]" data-id="element-103">
            Descargar Plan 21 Días... Alta Proteína.
          </a>

          <div className="flex items-center justify-center gap-2 text-charcoal-light text-sm mb-8" data-id="element-104">
            <ShieldCheck className="w-4 h-4 text-olive" data-id="element-105" />
            <span data-id="element-106">7 días de garantía — Si no te sirve, no lo fuerces.</span>
          </div>

          <div className="pt-8 border-t border-cream-dark" data-id="element-107">
            <div className="flex flex-col md:flex-row items-center gap-6 text-left" data-id="element-108">
              <img src="https://cdn.magicpatterns.com/uploads/hWap33X3gzHf5FSzYn9sAd/21_Dias_Alta_Proteina.png" alt="Book Cover" className="w-24 h-auto rounded-lg shadow-md transform -rotate-3" data-id="element-109" />
              <div data-id="element-110">
                <p className="font-serif font-bold text-charcoal text-lg mb-1" data-id="element-111">
                  "Si estás cansada de reiniciar…"
                </p>
                <p className="text-charcoal-light" data-id="element-112">
                  Y estás lista para una forma de comer que aguante tu vida
                  real, descarga el plan y recupera tu paz mental.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}